/**
 * Copia texto para a área de transferência com fallback.
 *
 * `navigator.clipboard.writeText` pode falhar (permissão negada) em contextos
 * como iframes/webviews sem permissão explícita, páginas não-HTTPS, ou navegadores
 * mais restritivos. Quando isso acontece, caímos para o método clássico
 * (textarea oculto + document.execCommand('copy')), que funciona na maioria
 * dos navegadores mesmo sem a Clipboard API moderna.
 *
 * @param {string} text
 * @returns {Promise<boolean>} true se copiou com sucesso
 */
export const copyToClipboard = async (text) => {
  if (!text) return false;

  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // cai para o fallback abaixo
    }
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (err) {
    return false;
  }
};
